import { createSelector } from "@reduxjs/toolkit";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchRegionCafesAsync,
  fetchRegionsAsync,
  fetchSelectedCafeAndStationsAsync,
} from "../../reducers/diningReducer";
import { cafeListSelector, cafeSelector, regionListSelector } from "../../selectors/diningSelector";
import withAppInsights from "../AppInsights/AppInsights";
import CafeSelectorView from "./CafeSelectorView";

type SelectOption = {
  key: string;
  text: string;
};

// Option selector construction
const regionOptionsSelector = createSelector(regionListSelector, (regionList): SelectOption[] =>
  regionList.map((region) => ({
    key: region.id,
    text: region.name ?? "",
  })),
);

const cafeOptionsSelector = createSelector(cafeListSelector, (cafeList): SelectOption[] =>
  cafeList.map((cafe) => ({
    key: cafe.id,
    text: cafe.name,
  })),
);

export const CafeSelector = () => {
  const regionOptions = useSelector(regionOptionsSelector);
  const cafeOptions = useSelector(cafeOptionsSelector);
  const selectedCafe = useSelector(cafeSelector);
  const dispatch = useDispatch<any>();

  useEffect(() => {
    if (!regionOptions.length) {
      dispatch(fetchRegionsAsync());
    }
  }, [dispatch, regionOptions.length]);

  const onRegionSelect = (option?: SelectOption) => {
    if (option) {
      dispatch(fetchRegionCafesAsync(option.key));
    }
  };

  const onCafeSelect = (option?: SelectOption) => {
    if (option) {
      dispatch(fetchSelectedCafeAndStationsAsync(option.key));
    }
  };

  return (
    <CafeSelectorView
      regionOptions={regionOptions}
      cafeOptions={cafeOptions}
      onRegionSelect={onRegionSelect}
      onCafeSelect={onCafeSelect}
      selectedRegionId={selectedCafe?.regionId}
      selectedCafeId={selectedCafe?.id}
    />
  );
};

export default withAppInsights(CafeSelector);
